var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegionCategory = function SvgRegionCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#region-category_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#region-category_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE49E",
    d: "M16 27.387c4.474 0 8.1-1.612 8.1-3.6 0-1.989-3.626-3.6-8.1-3.6-4.473 0-8.1 1.611-8.1 3.6 0 1.988 3.627 3.6 8.1 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8952",
    d: "m16 23.787 5.454-5a8.12 8.12 0 0 0 2.666-6A8.15 8.15 0 0 0 16 4.607a8.147 8.147 0 0 0-8.14 8.146 8.12 8.12 0 0 0 2.667 6l3.153 2.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 15.087a2.253 2.253 0 1 0 0-4.507 2.253 2.253 0 0 0 0 4.507"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "region-category_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "region-category_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgRegionCategory;